import * as types from './mutation-types.js'
import blockingInfo from '@/services/api/blockingPrefs'

const state = {
  iabCategories: [],
  blockedIabCategories: [],
  blockedDomains: [],
  blockedDomainsTotal: 0
}

const actions = {
  clearBlockedDomains ({state, commit}) {
    commit(types.CLEAR_BLOCKED_DOMAINS)
  },
  clearIabCategories ({state, commit}) {
    commit(types.CLEAR_IAB_CATEGORIES)
  },
  async getBlockedDomains ({commit}, {podcastId, options}) {
    const result = await blockingInfo.getBlockedDomains(podcastId, options)

    commit(types.SET_BLOCKED_DOMAINS, result)
    return result
  },
  async getBlockedIabCategories ({commit}, podcastId) {
    const result = await blockingInfo.getBlockedIabCategories(podcastId)

    commit(types.SET_BLOCKED_IAB_CATEGORIES, result)
    return result
  },
  getIabCategories ({state, commit}) {
    const result = blockingInfo.getIabCategories()

    commit(types.SET_IAB_CATEGORIES, result)
    return result
  }
}

const mutations = {
  [types.CLEAR_BLOCKED_DOMAINS] (state) {
    state.blockedDomains = []
    state.blockedDomainsTotal = 0
  },
  [types.CLEAR_IAB_CATEGORIES] (state) {
    state.iabCategories = []
    state.blockedIabCategories = []
  },
  [types.SET_BLOCKED_DOMAINS] (state, domains) {
    state.blockedDomains = domains.collection
    // TODO: remove the option of using the collection length
    state.blockedDomainsTotal = domains.count || domains.collection.length
  },
  [types.SET_BLOCKED_IAB_CATEGORIES] (state, categoryIds) {
    state.blockedIabCategories = categoryIds
  },
  [types.SET_IAB_CATEGORIES] (state, categories) {
    state.iabCategories = categories
  }
}

const getters = {
  blockedDomains: state => state.blockedDomains,
  blockedDomainsTotal: state => state.blockedDomainsTotal,
  blockedIabCategories: state => state.blockedIabCategories,
  iabCategories: state => state.iabCategories
}

export default {
  state,
  actions,
  mutations,
  getters
}
